// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_hLV","cls2":"PaywallPage-cls2_bYl PaywallPage-cls1_hLV"};